const criteria = {
  standard: {
    label: "Standard",
    object: "asset",
    attribute: "assetValue",
    condition: "is",
    value: true,
  },
  propertyOwner: {
    label: "Property owner",
    object: "customerProfile",
    attribute: "livingArrangements",
    condition: "exists",
    value: "Property Owner",
  },
  hasDefault: {
    label: "Has default",
    object: "creditProfile",
    attribute: "hasAdverseCredit",
    condition: "exists",
    value: true,
  },
  noDefault: {
    label: "Has default",
    object: "creditProfile",
    attribute: "hasAdverseCredit",
    condition: "doesntExist",
    value: false,
  },
  dateOfBirthLessThan: (value) => ({
    label: `Age of customer <${value} years`,
    object: "customer",
    attribute: "dateOfBirth",
    condition: "lessThan",
    value,
  }),
  dateOfBirthGreaterThan: (value) => ({
    label: `Age of customer >${value} years`,
    object: "customer",
    attribute: "dateOfBirth",
    condition: "greaterThan",
    value,
  }),
  dateOfBirthBetween: (min, max) => ({
    label: `Age of customer ${min}-${max} years`,
    object: "customer",
    attribute: "dateOfBirth",
    condition: "betweenLow",
    value: {
      min,
      max,
    },
  }),
  nonGST: {
    label: "Not GST registered",
    object: "entity",
    attribute: "gst",
    condition: "isNot",
  },
  termIsLessThan: (value) => ({
    label: `Term <${value} months`,
    object: "loanDetails",
    attribute: "term",
    condition: "lessThan",
    value,
  }),
  termIsBetween: (min, max) => ({
    label: `Term ${min} - ${max} months`,
    object: "loanDetails",
    attribute: "term",
    condition: "betweenLow",
    value: {
      min,
      max,
    },
  }),
  termIsLessThanOrEqualTo: (value) => ({
    label: `Term max ${value} months`,
    object: "loanDetails",
    attribute: "term",
    condition: "lessThanOrEqualTo",
    value,
  }),
  termIsGreaterThan: (value) => ({
    label: `Term >${value} months`,
    object: "loanDetails",
    attribute: "term",
    condition: "greaterThan",
    value,
  }),
  depositGreaterThanOrEqualTo: (value) => ({
    label: "20% deposit",
    object: "loanDetails",
    attribute: "deposit",
    condition: "greaterThanOrEqualTo",
    value,
  }),
  nonPropertyOwner: {
    label: "Not a property owner",
    object: "customerProfile",
    attribute: "livingArrangements",
    condition: "doesntExist",
    value: "Property Owner",
  },
  eachCreditScoreGreaterThan: (value) => ({
    label: `Credit score >${value}`,
    object: "creditProfile",
    attribute: "score",
    condition: "eachIsGreaterThan",
    value,
  }),
  creditScoreGreaterThan: (value) => ({
    label: `Credit score >${value}`,
    object: "creditProfile",
    attribute: "score",
    condition: "greaterThan",
    value,
  }),
  creditScoreLessThan: (value) => ({
    label: `Credit score <${value}`,
    object: "creditProfile",
    attribute: "score",
    condition: "lessThan",
    value,
  }),
  creditScoreBetween: (min, max) => ({
    label: `Credit score ${min} - ${max}`,
    object: "creditProfile",
    attribute: "score",
    condition: "between",
    value: {
      min,
      max,
    },
  }),
  employmentType: (value) => ({
    label: "Employment type",
    object: "employer",
    attribute: "employmentType",
    condition: "hasOne",
    value,
  }),
  timeOfEmploymentGreaterThan: (value) => ({
    label: `Employed >${value} months`,
    object: "employer",
    attribute: "timeOfEmployment",
    condition: "greaterThan",
    value,
  }),
  livingArrangements: (value) => ({
    label: "Living arrangements",
    object: "customerProfile",
    attribute: "livingArrangements",
    condition: "hasOne",
    value,
  }),
  typeOfSale: (value) => ({
    label: "Type of sale",
    object: "asset",
    attribute: "typeOfSale",
    condition: "hasOne",
    value,
  }),
  typeOfSaleMany: (value) => ({
    label: "Type of sale",
    object: "asset",
    attribute: "typeOfSale",
    condition: "hasOne",
    value,
  }),
  hasDeposit: (value) => ({
    label: `${value}% deposit`,
    object: "loanDetails",
    attribute: "deposit",
    condition: "greaterThanOrEqualTo",
    value,
  }),
  depositBetween: (min, max) => ({
    label: `Deposit ${min}-${max}% `,
    object: "loanDetails",
    attribute: "deposit",
    condition: "between",
    value: {
      min,
      max,
    },
  }),
  noDeposit: (value) => ({
    label: `No deposit`,
    object: "loanDetails",
    attribute: "deposit",
    condition: "zero",
    value,
  }),
  assetValueGreaterThan: function (value) {
    return {
      label: `Asset value >$${value}`,
      object: "asset",
      attribute: "assetValue",
      condition: "greaterThan",
      value,
    };
  },
  assetValueBetween: function (min, max) {
    return {
      label: `Asset value $${min} - $${max}`,
      object: "asset",
      attribute: "assetValue",
      condition: "between",
      value: {
        min,
        max,
      },
    };
  },
  assetType: function (value) {
    return {
      label: "Asset Type",
      object: "asset",
      attribute: "assetType",
      condition: "hasOne",
      value,
    };
  },
  assetCondition: function (value) {
    return {
      label: "Asset Condition",
      object: "asset",
      attribute: "condition",
      condition: "hasOne",
      value,
    };
  },
  ageOfAssetNewOrDemo: {
    label: `Asset New/Demo`,
    object: "asset",
    attribute: "ageOfAsset",
    condition: "hasOne",
    value: ["New", "Demo"],
  },
  ageOfAssetGreaterThan: function (value) {
    return {
      label: `Asset age >${value} mths`,
      object: "asset",
      attribute: "ageOfAsset",
      condition: "greaterThan",
      value,
    };
  },
  ageOfAssetGreaterThanOrEqualTo: function (value) {
    return {
      label: `Asset age >${value} mths`,
      object: "asset",
      attribute: "ageOfAsset",
      condition: "greaterThanOrEqualTo",
      value,
    };
  },
  ageOfAssetLessThan: function (value) {
    return {
      label: `Asset age <${value} mths`,
      object: "asset",
      attribute: "ageOfAsset",
      condition: "lessThan",
      value,
    };
  },
  ageOfAssetLessThanOrEqualTo: function (value) {
    return {
      label: `Asset age <${value} mths`,
      object: "asset",
      attribute: "ageOfAsset",
      condition: "lessThanOrEqualTo",
      value,
    };
  },
  ageOfAssetBetween: function (min, max) {
    return {
      label: `Asset age ${min} - ${max} mths`,
      object: "asset",
      attribute: "ageOfAsset",
      condition: "betweenLow",
      value: {
        min,
        max,
      },
    };
  },
  ageOfAssetAtEndGreaterThan: function (value) {
    return {
      label: `End of term age >${value} yrs`,
      object: "asset",
      attribute: "ageOfAssetAtEnd",
      condition: "greaterThan",
      value,
    };
  },
  ageOfAssetAtEndLessThan: function (value) {
    return {
      label: `End of term age <${value} yrs`,
      object: "asset",
      attribute: "ageOfAssetAtEnd",
      condition: "lessThan",
      value,
    };
  },
  ageOfAssetAtEndBetween: function (min, max) {
    return {
      label: `End of term age ${min} - ${max}yrs`,
      object: "asset",
      attribute: "ageOfAssetAtEnd",
      condition: "between",
      value: {
        min,
        max,
      },
    };
  },
  loanAmountGreaterThan: function (value) {
    return {
      label: `Loan amount >$${value}`,
      object: "loanDetails",
      attribute: "loanAmount",
      condition: "greaterThan",
      value,
    };
  },
  loanAmountLessThan: function (value) {
    return {
      label: `Loan amount <$${value}`,
      object: "loanDetails",
      attribute: "loanAmount",
      condition: "lessThan",
      value,
    };
  },
  loanAmountBetween: function (min, max) {
    return {
      label: `Loan amount $${min} - $${max}`,
      object: "loanDetails",
      attribute: "loanAmount",
      condition: "betweenLow",
      value: {
        min,
        max,
      },
    };
  },
  loanPurpose: function (value) {
    return {
      label: `Loan purpose: ${value}`,
      object: "loanDetails",
      attribute: "purpose",
      condition: "hasOne",
      value,
    };
  },
  turnoverGreaterThan: function (value) {
    return {
      label: `Turnover >$${value}`,
      object: "entity",
      attribute: "turnover",
      condition: "greaterThan",
      value,
    };
  },
  turnoverLessThan: function (value) {
    return {
      label: `Turnover <$${value}`,
      object: "entity",
      attribute: "turnover",
      condition: "lessThan",
      value,
    };
  },
  turnoverBetween: function (min, max) {
    return {
      label: `Turnover $${min} - $${max}`,
      object: "entity",
      attribute: "turnover",
      condition: "betweenLow",
      value: {
        min,
        max,
      },
    };
  },
  timeInBusinessBetween: function (min, max) {
    return {
      label: `Time in business ${min} - ${max} mths`,
      object: "entity",
      attribute: "timeInBusiness",
      condition: "betweenLow",
      value: {
        min: min,
        max: max,
      },
    };
  },
  timeInBusinessLessThan: function (value) {
    return {
      label: `Time in business <${value} mths`,
      object: "entity",
      attribute: "timeInBusiness",
      condition: "lessThan", // "greaterThan",
      value,
    };
  },
  timeInBusinessGreaterThan: function (value) {
    return {
      label: `Time in business >${value} mths`,
      object: "entity",
      attribute: "timeInBusiness",
      condition: "greaterThan", // "lessThan",
      value,
    };
  },
  gstRegistrationGreaterThan: function (value) {
    return {
      label: `GST reg. >${value} mths`,
      object: "entity",
      attribute: "gst",
      condition: "greaterThan", // lessThan
      value,
    };
  },
  gstRegistrationLessThan: function (value) {
    return {
      label: `GST reg. <${value} mths`,
      object: "entity",
      attribute: "gst",
      condition: "lessThan", // greaterThan
      value,
    };
  },
  gstRegistrationBetween: function (min, max) {
    return {
      label: `GST reg. ${min} - ${max} mths`,
      object: "entity",
      attribute: "gst",
      condition: "betweenLow",
      value: {
        min,
        max,
      },
    };
  },
  customerDefaultAmountLessThan: (value) => ({
    label: `Customer defaults value <$${value}`,
    object: "customer",
    attribute: "defaultValue",
    condition: "lessThan",
    value: value,
  }),
  brokerageAmount: (min, max) => ({
    label: `Brokerage amount`,
    object: "loanDetails",
    attribute: "brokerageRate",
    condition: "betweenLow",
    value: {
      min,
      max,
    },
  }),
  brokerageIsEqualTo: (value) => ({
    label: `Brokerage`,
    object: "loanDetails",
    attribute: "brokerage",
    condition: "equal",
    value,
  }),
  brokerageIsBetween: (min, max) => ({
    label: `Brokerage`,
    object: "loanDetails",
    attribute: "brokerage",
    condition: "betweenLow",
    value: {
      min,
      max,
    },
  }),
  compound: (obj) => ({
    label: obj.name,
    object: "loanDetails",
    conditional: obj.conditional,
    condition: "compound",
    primary: obj.primary,
    criteria: obj.criteria,
  }),
};
export default criteria;
